module.exports = __webpack_public_path__ + "static/media/ic_lock_icon_white.fafa30c9.svg";